// Core/components/Header/Header.tsx
import React, {useContext, useRef} from 'react';
import './Header.sass';
import {AuthContext, AuthContextType} from "Auth/AuthContext";
import {Link, useLocation} from "react-router-dom";
// Core/components/Header/NavLink.tsx
import NavLink from 'Core/components/Header/NavLink'
import LogoutIcon from '@mui/icons-material/Logout';
import {useSelector} from "react-redux";
import ThemeToggleButton from "Theme/ThemeToggleButton";
import {useTheme} from "Theme/ThemeContext";
import UserAvatar from "User/UserAvatar";
import {useNavigation} from "Core/components/Header/HeaderProvider";
import MobileNavigationMenu from "Core/components/Header/MobileNavigationMenu";
import AdminLink from "Core/components/AdminLink";
import LogsLink from "Core/components/LogsLink";
import DesktopNavigationMenu from "Core/components/Header/DesktopNavigationMenu";
import {FC, FR, FRCC} from "WideLayout/Layouts";
import {companyLinks} from "Company/companyLinks";
import LightExtendingButton from "Core/components/elements/AbsoluteExtendingButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import RelativeExtendingButton from "Core/components/elements/RelativeExtendingButton";
import ConsoleLogger from "Core/components/ConsoleLogger";

export const headerHeight = 70;

const Header: React.FC = () => {
    const {
        toggleMobileMenu,
        headerRef,
        mobileNavigationContent,
        desktopNavigationContent,
        hideMobileMenu,
        profileBtnVisible,
        logoContent,
        mobileMenuEnabled,
        desktopMenuEnabled
    } = useNavigation();
    const btnToggleMenuRef = useRef<HTMLDivElement>(null);
    const {user, isAuthenticated, logout} = useContext(AuthContext) as AuthContextType;
    const location = useLocation();
    const {plt} = useTheme();
    const isHeaderVisible = useSelector((state: any) => state.visibility.isHeaderVisible);
    const isGtLg = useMediaQuery('(min-width: 1000px)');
    const isGt1630 = useMediaQuery('(min-width: 1630px)');

    // Теперь не привязываемся к медиазапросу, а показываем меню по состоянию.
    // При желании разработчик может сам управлять состоянием mobileMenuEnabled и desktopMenuEnabled
    // прямо из компонента или контекста.

    if (!isHeaderVisible) return null;
    return (
        <header ref={headerRef} className={`frbc gap-4 px-4`} style={{height: headerHeight}}>
            <FRCC
                style={{gap: isGt1630 ? '120px' : '32px'}}
                  onClick={hideMobileMenu}
                  color={plt.text.primary60}>
                {logoContent}
                {isGtLg &&
                    <FR style={{fontSize: '1.2rem'}} g={3} mr={'auto'}>
                        <NavLink onClick={() => {
                            hideMobileMenu()
                            window.location.href = companyLinks.blog
                        }} to={companyLinks.blog}>Блог</NavLink>
                        <NavLink onClick={() => {
                            hideMobileMenu()
                            window.location.href = companyLinks.consultations
                        }} to={companyLinks.consultations}>Консультации</NavLink>
                        <LightExtendingButton text={'Для психологов'} clsMenu={'fs-6 gap-2'} clsMenuActive={'pb-2'}>
                            <NavLink onClick={() => {
                                hideMobileMenu()
                                window.location.href = companyLinks.for_psy_intervision
                            }} to={'#'}>Интервизии</NavLink>
                            <NavLink onClick={() => {
                                hideMobileMenu()
                                window.location.href = companyLinks.for_psy_supervision
                            }} to={'#'}>Супервизии</NavLink>
                        </LightExtendingButton>
                        <NavLink onClick={() => {
                            hideMobileMenu()
                            window.location.href = companyLinks.for_business
                        }} to={'#'}>Для бизнеса</NavLink>
                        <NavLink onClick={() => {
                            hideMobileMenu()
                            window.location.href = companyLinks.for_tests
                        }} to={'#'}>Тесты</NavLink>
                    </FR>}
            </FRCC>
            <FRCC g={3} mt={'5px'}>
                {desktopMenuEnabled && desktopNavigationContent && (
                    <DesktopNavigationMenu cls={'ms-auto'}>
                        {desktopNavigationContent}
                    </DesktopNavigationMenu>
                )}
                {mobileMenuEnabled && mobileNavigationContent && (
                    <>
                        <MobileNavigationMenu>
                            {!isGtLg && <FC g={1}>
                                <NavLink onClick={() => {
                                    hideMobileMenu()
                                    window.location.href = companyLinks.blog
                                }} to={companyLinks.blog}>БЛОГ</NavLink>
                                <NavLink onClick={hideMobileMenu} to={companyLinks.consultations}>КОНСУЛЬТАЦИИ</NavLink>
                                <RelativeExtendingButton text={'ДЛЯ ПСИХОЛОГОВ'}
                                                         cls={'h-min'}
                                                         isExpandedInitial={true}
                                                         changeStateBlock={true}
                                                         clsMenu={'fs-6 gap-2'}
                                                         clsMenuActive={'pb-2'}>
                                    <NavLink onClick={hideMobileMenu}
                                             to={companyLinks.for_psy_intervision}>ИНТЕРВИЗИЯ</NavLink>
                                    <NavLink onClick={hideMobileMenu}
                                             to={companyLinks.for_psy_supervision}>СУПЕРВИЗИЯ</NavLink>
                                </RelativeExtendingButton>
                                <NavLink onClick={hideMobileMenu} to={companyLinks.for_business}>ДЛЯ БИЗНЕСА</NavLink>
                                <NavLink onClick={hideMobileMenu} to={companyLinks.for_tests}>Тесты</NavLink>
                                {(user?.is_test || user?.is_staff) && <ConsoleLogger/>}
                            </FC>}
                            {mobileNavigationContent}
                        </MobileNavigationMenu>

                        <FRCC cls={'header-tools'}>
                            <div ref={btnToggleMenuRef} className="btn-toggle-header-mobile-menu"
                                 onClick={toggleMobileMenu}>
                                <span style={{backgroundColor: plt.bg.contrast60}}></span>
                                <span style={{backgroundColor: plt.bg.contrast60}}></span>
                                <span style={{backgroundColor: plt.bg.contrast60}}></span>
                            </div>
                        </FRCC>
                    </>
                )}
                <FRCC g={1}>
                    {profileBtnVisible && !location.pathname.includes('/profile') && (
                        <Link to={'/consultations'}>
                            <UserAvatar
                                size={user?.avatar ? '37px' : '30px'}
                                className={`fs-1`}
                                avatar={user?.avatar}
                            />
                        </Link>
                    )}
                    {isAuthenticated && user?.is_staff && (
                        <>
                            <AdminLink/>
                            <LogsLink/>
                        </>
                    )}
                    {isAuthenticated && user?.is_staff && (
                        <ThemeToggleButton className={`fs-2`}/>
                    )}
                    {isAuthenticated && (
                        <LogoutIcon
                            className={`fs-2`}
                            style={{color: plt.text.primary60}}
                            onClick={logout}
                        />
                    )}
                </FRCC>
            </FRCC>
        </header>
    );
};

export default Header;